import type { EventListQuery, EventListResponse } from "@cdt/shared";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { fetchEvents } from "@/lib/eventsApi";

export function eventsQueryKey(query: EventListQuery) {
  return ["events", query] as const;
}

export function useEventsQuery(query: EventListQuery) {
  return useQuery<EventListResponse>({
    queryKey: eventsQueryKey(query),
    queryFn: () => fetchEvents(query),
    placeholderData: keepPreviousData,
    staleTime: 10_000,
  });
}
